/**
 * Cartina d'Italia stilizzata — path SVG affinati (viewBox 0 0 400 480)
 */

export const VIEWBOX = { w: 400, h: 480 };

export const REGION_MACRO = {
  'valle-aosta': 'nord',
  piemonte: 'nord',
  liguria: 'nord',
  lombardia: 'nord',
  trentino: 'nord',
  veneto: 'nord',
  friuli: 'nord',
  emilia: 'nord',
  toscana: 'centro',
  umbria: 'centro',
  marche: 'centro',
  lazio: 'centro',
  abruzzo: 'centro',
  molise: 'centro',
  campania: 'sud',
  puglia: 'sud',
  basilicata: 'sud',
  calabria: 'sud',
  sicilia: 'isole',
  sardegna: 'isole',
};

export const REGION_CENTROIDS = {
  'valle-aosta': { x: 118, y: 52 },
  piemonte: { x: 95, y: 95 },
  liguria: { x: 118, y: 128 },
  lombardia: { x: 155, y: 88 },
  trentino: { x: 195, y: 58 },
  veneto: { x: 218, y: 88 },
  friuli: { x: 258, y: 72 },
  emilia: { x: 178, y: 128 },
  toscana: { x: 158, y: 168 },
  umbria: { x: 198, y: 178 },
  marche: { x: 238, y: 168 },
  lazio: { x: 198, y: 218 },
  abruzzo: { x: 248, y: 208 },
  molise: { x: 268, y: 228 },
  campania: { x: 228, y: 258 },
  puglia: { x: 298, y: 248 },
  basilicata: { x: 258, y: 278 },
  calabria: { x: 268, y: 328 },
  sicilia: { x: 228, y: 418 },
  sardegna: { x: 68, y: 298 },
};

/** Viewport pan leggero — non taglia le regioni */
export const MACRO_VIEWPORT = {
  nord:   { x: 0, y: 8, scale: 1.05 },
  centro: { x: 0, y: -24, scale: 1.08 },
  sud:    { x: 0, y: -72, scale: 1.12 },
  isole:  { x: 0, y: -100, scale: 1.1 },
};

export const FULL_VIEWPORT = { x: 0, y: 0, scale: 1 };

export const REGION_PATHS = {
  'valle-aosta': 'M 108 38 L 128 32 L 132 48 L 118 58 L 102 52 Z',
  piemonte: 'M 62 58 L 138 48 L 148 108 L 118 128 L 72 118 L 52 82 Z',
  liguria: 'M 72 118 L 118 128 L 128 158 L 98 168 L 68 148 Z',
  lombardia: 'M 118 58 L 188 52 L 198 108 L 158 118 L 128 88 Z',
  trentino: 'M 178 28 L 228 22 L 238 72 L 198 82 L 168 58 Z',
  veneto: 'M 198 52 L 258 48 L 268 108 L 228 118 L 198 88 Z',
  friuli: 'M 258 48 L 298 42 L 308 88 L 278 98 L 258 72 Z',
  emilia: 'M 98 128 L 248 118 L 258 158 L 178 168 L 88 158 Z',
  toscana: 'M 88 158 L 188 152 L 198 198 L 138 208 L 78 188 Z',
  umbria: 'M 188 152 L 228 148 L 238 198 L 208 208 L 188 178 Z',
  marche: 'M 228 148 L 278 142 L 288 198 L 248 208 L 228 178 Z',
  lazio: 'M 138 198 L 248 188 L 258 248 L 198 258 L 128 238 Z',
  abruzzo: 'M 248 188 L 298 182 L 308 238 L 268 248 L 248 218 Z',
  molise: 'M 268 238 L 308 232 L 318 268 L 288 278 L 268 258 Z',
  campania: 'M 178 248 L 278 238 L 288 288 L 228 298 L 168 278 Z',
  puglia: 'M 278 218 L 348 208 L 358 278 L 308 288 L 278 258 Z',
  basilicata: 'M 228 278 L 278 268 L 288 318 L 248 328 L 218 308 Z',
  calabria: 'M 248 308 L 288 298 L 298 378 L 268 388 L 238 348 Z',
  sicilia: 'M 158 388 L 298 378 L 308 428 L 218 438 L 148 418 Z',
  sardegna: 'M 28 248 L 108 238 L 118 348 L 58 358 L 22 308 Z',
};

export const ITALIA_OUTLINE =
  'M 52 58 C 62 38 98 28 138 32 C 178 28 228 22 298 42 C 318 68 308 118 298 168 C 288 218 278 268 268 318 C 258 358 248 378 228 388 C 198 398 168 408 148 418 C 128 408 108 358 98 298 C 88 248 78 198 72 158 C 62 118 52 88 52 58 Z';

export const SARDEGNA_OUTLINE =
  'M 22 248 C 48 232 98 228 118 248 C 128 288 118 338 88 358 C 58 368 28 348 22 308 Z';

export const SICILIA_OUTLINE =
  'M 148 388 C 198 378 278 378 308 398 C 318 418 298 438 228 438 C 178 438 148 418 148 388 Z';

export const MACRO_BANDS = {
  nord:   { y: 20, height: 150, label: 'Nord' },
  centro: { y: 145, height: 120, label: 'Centro' },
  sud:    { y: 235, height: 100, label: 'Sud' },
  isole:  { y: 360, height: 110, label: 'Isole' },
};

export function regionMacro(id) {
  return REGION_MACRO[id] || 'centro';
}
